/**
 * @generated SignedSource<<5101cb0f9f5903484acfbb0e83a5c8f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaregiverAbsenceReason = "OTHER" | "VACATION" | "SICK" | "%future added value";
export type CreateCaregiverAbsenceInput = {
  from: string;
  to: string;
  reason: CaregiverAbsenceReason;
  clientMutationId?: string | null;
};
export type CreateAbsenceFormMutation$variables = {
  input: CreateCaregiverAbsenceInput;
  connections: ReadonlyArray<string>;
};
export type CreateAbsenceFormMutation$data = {
  readonly createCaregiverAbsence: {
    readonly absence: {
      readonly id: string;
      readonly from: string;
      readonly to: string;
      readonly reason: string;
    } | null;
  } | null;
};
export type CreateAbsenceFormMutation = {
  variables: CreateAbsenceFormMutation$variables;
  response: CreateAbsenceFormMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Absence",
  "kind": "LinkedField",
  "name": "absence",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "from",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "to",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAbsenceFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateCaregiverAbsencePayload",
        "kind": "LinkedField",
        "name": "createCaregiverAbsence",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateAbsenceFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateCaregiverAbsencePayload",
        "kind": "LinkedField",
        "name": "createCaregiverAbsence",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "absence",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AbsenceEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3d0d6b788062649aeb8ec1133196b81",
    "id": null,
    "metadata": {},
    "name": "CreateAbsenceFormMutation",
    "operationKind": "mutation",
    "text": "mutation CreateAbsenceFormMutation(\n  $input: CreateCaregiverAbsenceInput!\n) {\n  createCaregiverAbsence(input: $input) {\n    absence {\n      id\n      from\n      to\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c3d0cebb447a3777e4e910815fe65ff";

export default node;
